import { HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
    Router,
    Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot,
} from '@angular/router'
import { Observable, of } from 'rxjs'
import { CallerService } from '../services/caller.service'
import { OnlineStatusService } from '../services/online-status.service'
import { catchError } from 'rxjs/operators'

@Injectable({
    providedIn: 'root',
})
export class ProfilePageResolver implements Resolve<any> {
    constructor(
        private callerService: CallerService,
        private onlineStatusService: OnlineStatusService,
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<any> {
        // TODO: we need to cache this.
        return this.callerService.fetchAllNigeriaStatesAndLGAs()
        .pipe(
          catchError((error) => {
            // A resolver observable that completes without emitting (e.g. EMPTY) makes the
            // Router silently cancel navigation - the page just never changes, no error shown.
            // Emitting null instead lets the route activate so the failure is visible on the page.
            this.callerService.showNotification(
              this.onlineStatusService.isOnline
                ? 'Failed to load data'
                : "You're offline - some data won't load until you're back online.",
            )
            console.log('obs err 1', error)
            return of(null)
          })
        )

        // return of(true);
    }
}
